























































































































































































































































































































































































































































































































import Component, { mixins } from "vue-class-component";
import MyMixin from "@/mixins/datemixin";
import { Groupe } from "@/shared/Groupe";
import { Site } from "@/shared/Site";
import { MyOptions } from "@/charts/graphData";
// import { Watch } from "vue-property-decorator";
import MobileMixin from "@/mixins/mobileMixin";
import CaGraph from "@/homeGraph/CaGraph.vue";
import ListeSites from "@/components/listeSites.vue";
import CaDataPresta from "@/homeGraph/CaDataPresta.vue";
import CaData from "@/homeGraph/CaData.vue";
import Top10 from "@/homeGraph/top10.vue";
import HomeBk from "@/home/HomeBk.vue";
import HomeBuffalo from "@/home/HomeBuffalo.vue";
import HomeDashboard from "@/home/HomeDashboard.vue";
import TotalHome from "@/home/totalHome.vue";
import apexchart from "vue-apexcharts";
import HomeCalendar from "./Calendar.vue";

@Component({
  components: {
    CaGraph,
    ListeSites,
    CaData,
    Top10,
    TotalHome,
    CaDataPresta,
    HomeBk,
    HomeBuffalo,
    HomeDashboard,
    apexchart,
    HomeCalendar,
  },
})
export default class HomeCharts extends mixins(MyMixin, MobileMixin) {
  public selectedSites: Site[] = [];
  public myOptions: MyOptions = new MyOptions();
  public showSiteChooser: boolean = false;
  public ouPan: number = 0;
  public searchTxt: string = "";
  public showPeriodeChooser = false;
  public showServiceChooser = false;
  public showDateChooser: boolean = false;
  public myDate: string = "";
  public timer: any;
  public isTTC: boolean = true;
  public services: string[] = ["GLOBAL"];
  public showCalendar: boolean = false;
  public preLoadCalendar: boolean = false;
  public lastSites: any;
  public lastDate: string = "";
  public lastService: string = "";
  public allSites: Site[] = [];
  public allSelectedSites: Site[] = [];
  public searchTerm: string = "";
  public isRunning: boolean = true;

  /*
  @Watch("showSiteChooser", { immediate: true, deep: true })
  public onPropertyChanged(value: any, oldValue: any) {
    // console.log(this.myOptions);
    if (!this.showSiteChooser) {
      this.closeSiteSelector();
    }
  }
  */

  public mounted() {
    this.orderSites();
  }

  public handleSelectionChange() {
    this.orderSites();
    this.myOptions.site = this.allSelectedSites;
  }

  public orderSites() {
    const selectedItems = this.allSelectedSites;
    let unselectedItems: Site[] = [];
    if (!this.searchTerm) {
      unselectedItems = this.sites.filter(
        (item: Site) => !selectedItems.includes(item)
      );
    } else {
      unselectedItems = this.sites.filter(
        (item: Site) =>
          !selectedItems.includes(item) &&
          item.libelle.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
      );
    }
    this.allSites = selectedItems.concat(unselectedItems);
  }

  public searchSites() {
    this.orderSites();
  }

  public created() {
    if (this.isMobile()) {
      this.isTTC = false;
    }
    // Forcer BK en HT par défaut
    if (this.client === "BK") {
      this.isTTC = false;
    }
    console.log(this.client, this.getGlobal);
    this.myDate = new Date().toISOString().substr(0, 10);
    if (this.getGlobal) {
      this.myOptions.site = Array.from(this.sites);
    } else {
      this.myOptions.site = [this.sites[0]];
      // this.myOptions.site = this.sites.filter((site: Site) => site.libelle === "TORCY");
    }

    this.myOptions.periode = "J";
    this.myOptions.service = "GLOBAL";
    this.myOptions.date = new Date();
    this.services = ["GLOBAL"];
    // Initialiser lastDate avec la date actuelle
    this.lastDate = JSON.stringify(this.myOptions.date);
    this.lastService = "GLOBAL";
    this.$forceUpdate();
    // this.timer = setInterval(this.updateOptions, 600000);
    if (!this.getGlobal) {
      this.preLoadCalendar = true;
    }
    this.showCalendar = true;
    setTimeout(() => {
      this.showCalendar = false;
    }, 100);
  }

  public updateLastParameters(new_sites: any, new_date: string, new_service: string) {
    this.lastSites = JSON.parse(JSON.stringify(new_sites));
    this.lastDate = new_date;
    this.lastService = new_service;
  }

  public loaded() {
    this.isRunning = false;
    this.$emit("loaded");
  }

  public sameSites(lastSites: any, newSites: any) {
    const lastIds: any[] = [];
    const newIds: any[] = [];
    if (lastSites) {
      lastSites.forEach((element: any) => lastIds.push(element.restaurantId));
    } else {
      if (newSites) {
        return false;
      }
      return true;
    }
    if (newSites) {
      newSites.forEach((element: any) => newIds.push(element.restaurantId));
    } else {
      return false;
    }
    if (!lastIds.every((element: any) => newIds.includes(element))) {
      return false;
    }
    if (!newIds.every((element: any) => lastIds.includes(element))) {
      return false;
    }
    return true;
  }

  /**
   * methode d'affichage de la selection des sites
   */
  public openSiteSelector() {
    if (this.sites.length > 1) {
      this.showSiteChooser = true;
    }
  }

  /**
   * méthode de maj de la date
   */
  public updateDate(date: any) {
    this.myOptions.date = new Date(date);
  }
  /**
   * methode pour fermer le calendrier
   */
  public closeDatePicker() {
    this.showDateChooser = false;

    const lastDateFormatted = new Date(Date.parse(this.lastDate.slice(1, -1)));

    if (
      this.myOptions.date.toLocaleDateString() !== lastDateFormatted.toLocaleDateString()
    ) {
      this.myOptions.updateMe++;
    }
  }
  /**
   * methode de modification de la période
   */
  public setPeriode(periode: string) {
    this.myOptions.periode = periode;
    this.showPeriodeChooser = false;
    this.$forceUpdate();
  }
  /**
   * methode de modification du service
   */
  public setService(service: string) {
    this.showServiceChooser = false;
    this.myOptions.service = service;
    this.myOptions.updateMe++;
  }
  /**
   * methode d'ajout d'un site pour la présentation des graphs
   */
  public addSite(site: Site) {
    if (this.getGlobal) {
      if (this.myOptions.site.indexOf(site) === -1) {
        this.myOptions.site.push(site);
      } else {
        this.myOptions.site = this.myOptions.site.filter(
          (s: Site) => s.libelle !== site.libelle
        );
      }
    } else {
      this.myOptions.site = [site];
    }
    this.$forceUpdate();
  }

  public removeSite(site: Site) {
    // console.log("remove");
    this.myOptions.site = new Array();
  }
  /**
   * methode apellé avant la destruction du composant pour suppression de l'interval
   */
  public beforeDestroy() {
    clearInterval(this.timer);
  }

  public addServices(services: string[]) {
    this.services = ["GLOBAL"];
    services.forEach((service) => {
      if (!this.services.includes(service)) {
        this.services.push(service);
      }
    });
  }

  public JoursFeries(an: number) {
    const JourAn = new Date(an, 0, 1);
    const FeteTravail = new Date(an, 4, 1);
    const Victoire1945 = new Date(an, 4, 8);
    const FeteNationale = new Date(an, 6, 14);
    const Assomption = new Date(an, 7, 15);
    const Toussaint = new Date(an, 10, 1);
    const Armistice = new Date(an, 10, 11);
    const Noel = new Date(an, 11, 25);

    const G = an % 19;
    const C = Math.floor(an / 100);
    const H =
      (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) %
      30;
    const I =
      H -
      Math.floor(H / 28) *
        (1 -
          Math.floor(H / 28) *
            Math.floor(29 / (H + 1)) *
            Math.floor((21 - G) / 11));
    const J = (an * 1 + Math.floor(an / 4) + I + 2 - C + Math.floor(C / 4)) % 7;
    const L = I - J;

    const MoisPaques = 3 + Math.floor((L + 40) / 44);
    const JourPaques = L + 28 - 31 * Math.floor(MoisPaques / 4);
    const LundiPaques = new Date(an, MoisPaques - 1, JourPaques + 1);
    const Ascension = new Date(an, MoisPaques - 1, JourPaques + 39);
    const LundiPentecote = new Date(an, MoisPaques - 1, JourPaques + 50);

    const joursFeries = new Array(
      JourAn,
      LundiPaques,
      FeteTravail,
      Victoire1945,
      Ascension,
      LundiPentecote,
      FeteNationale,
      Assomption,
      Toussaint,
      Armistice,
      Noel
    );

    joursFeries.forEach((x) => {
      x.setDate(x.getDate() + 1);
    });

    const result = joursFeries.map((x) => x.toISOString().substr(0, 10));

    return result;
  }

  public closeCalendar(date: Date) {
    this.showCalendar = false;
  }

  public closeSiteSelector() {
    this.showSiteChooser = false;
    if (
      !this.sameSites(this.lastSites, this.myOptions.site)
    ) {
      this.myOptions.updateMe++;
    }
  }

  /**
   * incrementation permettant de mettre à jour les graphs
   */
  private updateOptions() {
    if (this.myOptions.periode === "J") {
      this.myOptions.updateMe++;
    }
  }

  get groupes(): Groupe[] {
    return this.$store.getters["login/groupements"];
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get getGlobal(): boolean {
    return this.$store.getters["getGlobal"];
  }
}
